import utils from "../common/util";
import * as cmpTruthDareBtn from "./cmp-truth-dare-btn";
import * as cmpLogResultsBtn from "./cmp-log-results-btn";
import * as cmpQuestionContainer from "./cmp-question-container";
import * as cmpCountdownTimer from "./cmp-countdown-timer";
import * as cmpPlayerNameContainer from "./cmp-player-name-container";
import * as cmpPageHeader from "./cmp-page-header";

const cmpFlashScreen = {
    component: null,

    /**
     * Initialise the Flash Screen
     * @param element
     */
    init: function (element)
    {
        utils.log('cmpFlashScreen initiated : #' + element.id, 'info');

        const _ = utils.setEnvironment(this);
        _.component = element;

        _.onClickEvent(element);
    },

    /**
     * Add a click event listener to the buttons
     * @param element
     */
    onClickEvent: function (element)
    {
        const _ = this;

        element.addEventListener('click', (e) =>
        {
            if ((e.target).id === 'flash-screen__continue-button') {
                _.hideFlashScreen();
                cmpTruthDareBtn.default.showTruthDareButtons(false);
                utils.showHideElement(_.gameLevelContainer, 'show');
            }

            if ((e.target).id === 'flash-screen__home-button') {
                window.location.href = '/home';
            }
        });

    },

    /**
     * Display the flash screen with an appropriate style and message
     * @param passFail
     * @param backgroundImage
     * @param imageOpacity
     */
    showFlashScreen: function (passFail, backgroundImage = null, imageOpacity = '0.8')
    {
        const _ = this;

        _.scoreContainer.innerText = (passFail === 'pass' ? '+' : '-') + _.dataContainer.getAttribute('data-play-score');
        _.component.classList.add(passFail);

        // Show and hide the flash screen
        _.component.addEventListener('transitionend', function showPanels(e)
        {
            if (e.propertyName !== 'opacity') return;

            cmpTruthDareBtn.default.showTruthDareButtons();
            cmpLogResultsBtn.default.hideLogResultsButtons();
            cmpPlayerNameContainer.default.updatePlayerName();
            cmpLogResultsBtn.default.swapDataContainerVariables();
            cmpQuestionContainer.default.hideQuestionContainer();
            cmpCountdownTimer.default.hideCountdownTimer();

			// reinstate the log results button in case we hid any
	        cmpLogResultsBtn.default.showButton('opponent-failed-btn');
	        cmpLogResultsBtn.default.showButton('player-failed-btn');
	        cmpLogResultsBtn.default.showButton('task-completed-btn');

            if (backgroundImage) {
	            document.documentElement.style.setProperty('--background', 'url("' + backgroundImage + '")  ');
            }
			if (imageOpacity) {
	            document.documentElement.style.setProperty('--backgroundOpacity', imageOpacity );
            }

            utils.sleep(500).then(() =>
            {
                _.hideFlashScreen();
            });

            _.component.removeEventListener('transitionend', showPanels, false);
        }, false);

        _.component.classList.add('active');
    },

    /**
     * Show the 'level up' flash screen
     * @param data
     */
    showLevelUpScreen: function (data)
    {
        /** @namespace data.scores **/
        const _ = this;

        // hide all elements from the page
        cmpPageHeader.default.hidePageHeader();
        cmpPlayerNameContainer.default.hidePlayerNameContainer();

        // create  divs for the scores
        let scores = '';
        for (const name in data.scores) {
            if (data.scores.hasOwnProperty(name)) {
                scores += `<div class="score">
                    <span class="score-name">${name}</span>
                    <span class="score-value">${data.scores[name]}</span>
                </div>`;
            }
        }

        // create a continue button if we have somewhere to continue to
        let actionButton;

        if (data.gameLevelName === 'Game Over') {
            actionButton = '<button id="flash-screen__home-button" class="btn">Return Home</button>';
        } else {
            actionButton = '<button id="flash-screen__continue-button" class="btn">Continue</button>';
        }

        // create a heading for the scores
        let scoreHeading = (data.gameLevelId) ? 'Current Scores' : 'Final Scores';

        // Dynamically create the content of the level up screen
        _.scoreContainer.innerHTML = data.message
            + actionButton
            + '<div id="flash-screen__score-container"><h2>' + scoreHeading + '</h2>'
            + '<div id="flash-screen__score-container__scores">'
            + scores
            + '</div>'
            + '</div>';
        _.flashScreenContinueButton = document.getElementById('flash-screen__continue-button');
        _.component.classList.add('level-up');


        // Show and hide the flash screen
        utils.oneTimeListener(_.component, 'transitionend', (e) =>
        {
			if(!['background-color', 'color'].includes(e.propertyName)) { return; }

			// update the game level
            cmpPageHeader.default.updateGameLevel(data.gameLevelName, data.gameLevelNumber);
        });

        // utils.showHideElement(_.gameLevelContainer, 'hide');
        _.component.classList.add('active');
    },

    /**
     * Hide the flash screen and continue the app
     */
    hideFlashScreen: function ()
    {
        const _ = this;

        ['active', 'pass', 'fail', 'level-up'].forEach((cssClass) =>
        {
            _.component.classList.remove(cssClass);
        });

        cmpPageHeader.default.showPageHeader();
        cmpPlayerNameContainer.default.showPlayerNameContainer();
    }
}

export default cmpFlashScreen;
